import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingDecorationsAvailable } from "../selectors/selectBuildingDecorationsAvailable";
export var checkAnyDecorationConstructionInProgressAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var availableDecorationBuildings = selectBuildingDecorationsAvailable(state);
    var isAnyDecorationBuildingInConstruction = availableDecorationBuildings.some(utilBuildings.isUnderConstruction);
    return isAnyDecorationBuildingInConstruction ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyDecorationConstructionInProgressAvailable.ts
// module id = 2368
// module chunks = 3